import { useEffect } from "react";
import { useUrlParams } from '../hooks'
import { useRoute } from '../api'
import { useGeolocation, GEOLOCATION_STATUS } from '../slices/geolocation'

function waitForGtagAndSetUserProperty(key, value, retries = 10, delay = 300) {
  let attempt = 0;

  function trySet() {
    if (window.gtag && typeof window.gtag === 'function') {
      window.gtag('set', 'user_properties', { [key]: value });
      //console.log(`[GA] Set user property: ${key} = ${value}`);
    } else if (attempt < retries) {
      attempt++;
      setTimeout(trySet, delay);
    } else {
      console.warn('[GA] gtag not available after max retries');
    }
  }

  trySet();
}

function pointInExtent([lng, lat], [minLng, minLat, maxLng, maxLat]) {
  return lng >= minLng && lng <= maxLng && lat >= minLat && lat <= maxLat;
}

const Analytics = (props) => {
  const { route_id } = useUrlParams(['route_id']);
  const route = useRoute({ routeId: route_id });
  const { status, lnglat } = useGeolocation();

  // Set 'isinstalled' once on mount
  useEffect(() => {
    const isStandalone =
      window.matchMedia('(display-mode: standalone)').matches ||
      window.navigator.standalone === true;

    const value = isStandalone ? 'yes' : 'no';
    waitForGtagAndSetUserProperty('isinstalled', value);
  }, []);

  // Check if user is on trail when geolocation is ready
  useEffect(() => {
    if (status !== GEOLOCATION_STATUS.FIXED || !route || !lnglat) return;

    let isOnTrail = 'no';
    for (const trail of route.trails) {
      if (trail.extent && pointInExtent(lnglat, trail.extent)) {
        isOnTrail = 'yes';
        break;
      }
    }

    waitForGtagAndSetUserProperty('isontrail', isOnTrail);
  }, [status, lnglat, route]);

  return null;
}


export default Analytics;
